export interface VarcharDatatypeInterface extends String {
  data?: string;
}

export class VarcharDatatypeClass extends String
  implements VarcharDatatypeInterface {
  data?: string;
  max_length?: number;
  not_null?: boolean;
  is_unique?: boolean;
  default_value?: string;
}
